import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ButtonsBar from '../../components/buttons-bar/buttons-bar';
import Empty from '../../components/empty/empty';
import ErrorComponent from '../../components/error/error';
import FeatureTitle from '../../components/feature-title/feature-title';
import List from '../../components/list/list';
import Loading from '../../components/loading/loading';
import SubmitButton from '../../components/submit-button/submit-button';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerFormat,
} from '../../models/base-content-container';

// Helpers
import { classroomsToLabel } from '../../helpers/announcement-helper';
import { exhibitionOnToLabel } from '../../helpers/gallery-helper';

// Services
import GalleryService from '../../services/gallery-service';
import SchoolService from '../../services/school-service';
import StorageService from '../../services/storage-service';

const GalleryList = () => {
  const titles: ListContentTitle[] = [
    { text: 'Título' },
    { text: 'Turmas' },
    { text: 'Data', align: 'right' },
    { text: 'Visualizados', align: 'right' },
  ];

  const [error, setError] = useState(false);
  const [galleryList, setGalleryList] = useState<ListContent[]>(null);

  useEffect(() => {
    const schoolService = new SchoolService();
    const storageService = new StorageService();
    const schoolId = storageService.getEmployee().schoolId;

    schoolService
      .getSchoolById(schoolId)
      .then((school) => {
        const galleryService = new GalleryService(school.uuid);

        return galleryService.listAllBackoffice();
      })
      .then((items) => {
        const newGalleryList: ListContent[] = items.map((item) => ({
          linkTo: `/galerias/${item.id}`,
          data: [
            {
              text: item.title,
              customStyle: { maxWidth: '250px' },
            },
            {
              text: classroomsToLabel(item.classrooms),
            },
            {
              // exhibitionOn é a data que a galeria representa (o dia do passeio)
              // e é por ela que o app dos responsáveis ordena; o createdAt só
              // entra quando ela não foi preenchida.
              text:
                exhibitionOnToLabel(item.exhibitionOn) ||
                format(parseISO(item.createdAt.local), 'dd/MM/yyyy'),
              align: 'right',
            },
            {
              text: `${item.seenRecipients}/${item.totalRecipients}`,
              align: 'right',
            },
          ],
        }));

        setGalleryList(newGalleryList);
      })
      .catch(() => setError(true));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <ErrorComponent type='contentFull' />;

  if (!galleryList) return <Loading type='contentFull' />;

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.singleWithActionButtons}
      actionButtonPosition={BaseContentContainerActionButtonPosition.top}
    >
      <ButtonsBar pattern='firstSeparate'>
        <FeatureTitle title='galerias' />
        <Link to='/galerias/criar'>
          <SubmitButton value='criar nova galeria' variant='primary' />
        </Link>
      </ButtonsBar>

      {galleryList.length > 0 ? (
        <List titles={titles} contents={galleryList} />
      ) : (
        <Empty />
      )}
    </BaseContentContainer>
  );
};

export default GalleryList;
